<script setup lang="ts">
import type {
  Component
} from "../types";
import {onBeforeMount} from "vue";
import {updateHidden} from "../utils/ElementUtils.ts";
import {renderInvalidationRegistry, RenderInvalidationReason} from "../utils/RenderInvalidation.ts";

const {item} = defineProps<{
  item: Component,
}>();

updateHidden(item.props.id);
onBeforeMount(() => {
  renderInvalidationRegistry.requestRender(
      RenderInvalidationReason.LayoutLoaded,
      [item.props.id]
  );
});

</script>

<template>
  <!-- see docs/EXTRACTED_COMMENTS.md#c023 -->
  <!-- `image` is deliberately absent here — see docs/EXTRACTED_COMMENTS.md#c732 -->
  <component
      v-if="!(item.published.hide_flags.data || item.published.hide_flags.rule || item.published.hide_flags.render || item.published.hide_flags.anchoring || item.published.hide_flags.dedup || item.published.hide_flags.playlist || item.published.hide_flags.countdown || item.published.hide_flags.timer || item.published.hide_flags.children)"
      :is="item.type"
      v-bind="item.props"
      :item="item"
  >
    <slot></slot>
  </component>
</template>

<style scoped>

</style>